/* Remixicon — bundled locally to avoid CDN dependency */
/* @import must precede @tailwind directives (PostCSS requirement) */
@import "remixicon/fonts/remixicon.css";

@tailwind base;
@tailwind components;
@tailwind utilities;